import "./StaticPriceOverrideDetailsModal.styles.scss";

// Component Imports
import Calendar from "@/components/Calendar/Calendar";

// Type Imports
import {
  IIntervalsExtended,
  IStaticOverrideSchedule,
} from "@pulse-ui/types/components/AGTable";
import { IStaticPriceOverrideUploadModalStatus } from "@/pages/StaticPriceOverrides/StaticPriceOverrides.types";

// Mui Imports
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

const StaticPriceOverrideDetailsModal = ({
  open,
  schedule,
  handleClose,
  setStaticPriceOverrideUploadModalStatus,
  setIntervalsMap,
}: {
  open: boolean;
  schedule: IStaticOverrideSchedule | null;
  handleClose: () => void;
  setStaticPriceOverrideUploadModalStatus: React.Dispatch<
    React.SetStateAction<IStaticPriceOverrideUploadModalStatus>
  >;
  setIntervalsMap: React.Dispatch<
    React.SetStateAction<Map<string, IIntervalsExtended>>
  >;
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="static-price-override-details-modal-dialog-title"
      aria-describedby="static-price-override-details-modal-dialog-description"
      className="static-price-override-details-modal"
      fullScreen
    >
      <DialogTitle id="static-price-override-details-modal-dialog-title">
        {schedule?.symbol || "Static Price Override Details"}
      </DialogTitle>
      <DialogContent>
        <Calendar
          schedule={schedule}
          setStaticPriceOverrideUploadModalStatus={
            setStaticPriceOverrideUploadModalStatus
          }
          setIntervalsMap={setIntervalsMap}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          className="static-price-override-details-modal-close-button"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StaticPriceOverrideDetailsModal;
